import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  ICompareWordsDto,
  ICompareWordsResponseDto,
  IEvaluateShortAnswerFromTextDto,
  IEvaluateShortAnswerResponseDto,
  IExplainTextLlmDto,
  IExplainTextLlmResponseDto,
  IExtractWordsDto,
  IGenerateQuizFromWordsDto,
  IGenerateShortAnswerFromTextDto,
  IGenerateShortAnswerFromTextResponseDto,
  IGenerateStoryDto,
  IGenerateStoryResponseDto,
  IGetEtymologyDto,
  IGetEtymologyResponseDto,
  IGetTopicWordsDto,
  IGetTopicWordsResponseDto,
  IPromptLLMDto,
  IPromptLLMResponseDto,
  IQuizResponseDto,
  IRephraseSentenceDto,
  IRephraseSentenceResponseDto,
  ITranslateDto,
  ITranslateResponseDto,
  ITranslateSentenceDto,
  ITranslateSentenceResponseDto,
  ITranslateWordDto,
  ITranslateWordResponseDto,
} from '@shared';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class LLMApiService {
  readonly #http = inject(HttpClient);

  getEtymology(
    payload: IGetEtymologyDto,
  ): Observable<IGetEtymologyResponseDto> {
    return this.#http.post<IGetEtymologyResponseDto>(
      `${environment.apiUrl}/llm/get-etymology`,
      payload,
    );
  }

  prompt(payload: IPromptLLMDto): Observable<IPromptLLMResponseDto> {
    return this.#http.post<IPromptLLMResponseDto>(
      `${environment.apiUrl}/llm/prompt`,
      payload,
    );
  }

  generateStory(
    payload: IGenerateStoryDto,
  ): Observable<IGenerateStoryResponseDto> {
    return this.#http.post<IGenerateStoryResponseDto>(
      `${environment.apiUrl}/llm/generate-story`,
      payload,
    );
  }

  translateWord(
    payload: ITranslateWordDto,
  ): Observable<ITranslateWordResponseDto> {
    return this.#http.post<ITranslateWordResponseDto>(
      `${environment.apiUrl}/llm/translate-word`,
      payload,
    );
  }

  translate(payload: ITranslateDto): Observable<ITranslateResponseDto> {
    return this.#http.post<ITranslateResponseDto>(
      `${environment.apiUrl}/llm/translate`,
      payload,
    );
  }

  compareWords(
    payload: ICompareWordsDto,
  ): Observable<ICompareWordsResponseDto> {
    return this.#http.post<ICompareWordsResponseDto>(
      `${environment.apiUrl}/llm/compare-words`,
      payload,
    );
  }

  getTopicWords(
    payload: IGetTopicWordsDto,
  ): Observable<IGetTopicWordsResponseDto> {
    return this.#http.post<IGetTopicWordsResponseDto>(
      `${environment.apiUrl}/llm/get-topic-words`,
      payload,
    );
  }

  extractWords(
    payload: IExtractWordsDto,
  ): Observable<IGetTopicWordsResponseDto> {
    return this.#http.post<IGetTopicWordsResponseDto>(
      `${environment.apiUrl}/llm/extract-words`,
      payload,
    );
  }

  rephraseSentence(
    payload: IRephraseSentenceDto,
  ): Observable<IRephraseSentenceResponseDto> {
    return this.#http.post<IRephraseSentenceResponseDto>(
      `${environment.apiUrl}/llm/rephrase-sentence`,
      payload,
    );
  }

  translateSentence(
    payload: ITranslateSentenceDto,
  ): Observable<ITranslateSentenceResponseDto> {
    return this.#http.post<ITranslateSentenceResponseDto>(
      `${environment.apiUrl}/llm/translate-sentence`,
      payload,
    );
  }

  explainText(
    payload: IExplainTextLlmDto,
  ): Observable<IExplainTextLlmResponseDto> {
    return this.#http.post<IExplainTextLlmResponseDto>(
      `${environment.apiUrl}/llm/explain`,
      payload,
    );
  }

  generateShortAnswerFromText(
    payload: IGenerateShortAnswerFromTextDto,
  ): Observable<IGenerateShortAnswerFromTextResponseDto> {
    return this.#http.post<IGenerateShortAnswerFromTextResponseDto>(
      `${environment.apiUrl}/llm/generate-short-answer-exercise`,
      payload,
    );
  }

  evaluateShortAnswerFromText(
    payload: IEvaluateShortAnswerFromTextDto,
  ): Observable<IEvaluateShortAnswerResponseDto> {
    return this.#http.post<IEvaluateShortAnswerResponseDto>(
      `${environment.apiUrl}/llm/evaluate-short-answer-exercise`,
      payload,
    );
  }

  generateQuiz(
    payload: IGenerateQuizFromWordsDto,
  ): Observable<IQuizResponseDto> {
    return this.#http.post<IQuizResponseDto>(
      `${environment.apiUrl}/llm/generate-quiz`,
      payload,
    );
  }
}
